export const DEFAULT_PRODUCT_CATEGORY_OPTIONS = [
  { value: "powder", label: "Kopi Bubuk" },
  { value: "roasted beans", label: "Roasted Bean" },
  { value: "green beans", label: "Green Bean" },
  { value: "beverage", label: "Beverage" },
  { value: "merchandise", label: "Merchandise" },
  { value: "other", label: "Lainnya" },
];

export const DEFAULT_MATERIAL_CATEGORY_OPTIONS = [
  { value: "green beans", label: "Green Bean" },
  { value: "roasted beans", label: "Roasted Bean" },
  { value: "powder", label: "Kopi Bubuk" },
  { value: "pouch", label: "Pouch" },
  { value: "label", label: "Label" },
  { value: "packaging", label: "Packaging" },
  { value: "other", label: "Lainnya" },
];

export const toCategoryOptions = (categories = [], fallbackOptions = []) => {
  if (!Array.isArray(categories) || categories.length === 0) return fallbackOptions;

  return categories.map((category) => ({
    value: category.value,
    label: category.label || category.name || category.value,
  }));
};
